import { push } from 'react-router-redux';
import { createActions } from 'redux-actions';
import { put, select } from 'redux-saga/effects';
import { routes } from '../../../../constants';
import { apiActionResult, apiActions as commonApiActions, apiResourceActionCreator } from "../../common";
import { authTokenSelector } from '../../session';
import { RESOURCES, USER_RESOURCE_ENDPOINT } from './endpoints';

const actions = createActions({
  USER: {
    APPROVE_QUALIFICATION: (businessId, userId, qualificationId) => ({ businessId, userId, qualificationId }),
    API: {
      APPROVE_QUALIFICATION: apiResourceActionCreator('qualification')
    }
  }
})

export const apiAction = (authToken, qualificationId) => commonApiActions.authenticated.putFormData(`${USER_RESOURCE_ENDPOINT(RESOURCES.Qualification)}/${qualificationId}/approve`, authToken, {}, actions.user.api.approveQualification)

export function* approveQualification(action) {
  const authToken = yield select(authTokenSelector);

  if (authToken.idToken) {
    const { userId, qualificationId } = action.payload
    yield put(apiAction(authToken, qualificationId));

    const result = yield apiActionResult(actions.user.api.approveQualification);
    if (result.success) {
      yield put(push({ pathname: routes.app.teams.userProfiles(userId) }))
    }
  }
}

const configuration = {
  name: 'approveQualification',
  action: actions,
  sagas: approveQualification,
  reducers: {
    request: (state, action) => ({
      ...state,
      isUpdating: true
    }),
    success: (state, action) => ({
      ...state,
      isUpdating: false
    }),
    failed: (state, action) => ({
      ...state,
      isUpdating: false
    })
  }
}

export default configuration;


// WEBPACK FOOTER //
// ./src/state/modules/user/configurations/approveQualification.js